import { HttpClient } from '@angular/common/http'
import { Component } from '@angular/core'
import { Router } from '@angular/router'
import { Store } from '@ngxs/store'
import { IonicComponentLifecycles } from 'src/app/interfaces/component'
import { SetParticipantData } from 'src/app/store/actions/participant.actions'
import { environment } from 'src/environments/environment'
import { ParticipantState } from 'src/app/store/state/participant.state'
import { LogoutService } from 'src/app/services/logout.service'
import { AddEventLog } from 'src/app/store/actions/event-log.actions'

@Component({
  selector: 'mu-auth',
  styleUrls: ['./auth.page.scss'],
  templateUrl: './auth.page.html',
})
export class AuthPage implements IonicComponentLifecycles {
  constructor(
    private router: Router,
    private store: Store,
  ) {}

  ionViewDidEnter() {
    this.verifyCode()
  }

  async verifyCode(): Promise<void> {
    const ssoID = this.getCodeFromUrl('SSSOId')
    if (!ssoID) {
      this.router.navigate(['/', 'login'])
      return
    }
    this.getAccessToken(ssoID)
  }

  // FIXME: do proper url extraction
  getCodeFromUrl(param): string {
    const query = window.location.search
    if (!!query) {
      const urlParams = new URLSearchParams(query)
      return urlParams.get(param)
    }
  }

  async getAccessToken(ssoID) {
    this.store.dispatch(
      new SetParticipantData({
        ssoId: ssoID,
      })
    )
    const goto = this.getCodeFromUrl('goto')
    if (goto) {
      this.router.navigate(goto.split('.'))
    } else{
      this.router.navigate(['/', 'home'])
    }
  }
}
